import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    signatureLink: String,
    redirectUrl: String,
    containerId: String,
    isSandbox: Boolean,
  };

  connect() {
    this.initWidget();
  }

  initWidget() {
    const yousign = new Yousign({
      signatureLink: this.signatureLinkValue,
      iframeContainerId: this.containerIdValue,
      isSandbox: this.isSandboxValue,
    });

    const iframe = this.element.querySelector('#yousign-iframe');
    if (iframe) {
      iframe.classList.add('vh-100', 'w-100');
    }

    yousign.onSuccess(() => {
      window.location.replace(this.redirectUrlValue);
    });
  }
}
